export enum GridSize {
  FULL = 12,
  HALF = 6,
  THIRD = 3,
  QUARTER = 4,
  TWO_THIRDS = 8
}
